export class Queue<T> {
  data: T[]

  constructor(initVal?: T[]) {
    this.data = initVal ? [...initVal] : []
  }

  enqueue(element: T) {
    this.data.push(element)
  }

  dequeue() {
    return this.data.shift()
  }

  isEmpty() {
    return this.data.length === 0
  }

  peek(): T | undefined {
    return this.isEmpty() ? undefined : this.data[0]
  }

  clear() {
    this.data = []
  }

  size() {
    return this.data.length
  }

  // New method to find a pattern
  findPattern(pattern: string): { found: boolean; position: number } {
    const str = this.data.join('') // Convert the queue to a string
    const pos = str.indexOf(pattern)

    // if the pos is just the length of the pattern string
    // then it should be considered as not found
    if (pos === 0) {
      return {
        found: false,
        position: -1,
      }
    }

    return {
      found: pos !== -1,
      position: pos,
    }
  }
}
